import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import requireAuthContext from '../../authorization/requireAuthContext'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import entityTypePaginatedResponseFromJsonString = com.eidu.sharedlib.entity.api.types.entityTypePaginatedResponseFromJsonString
import IndexedPaginatedResponse = com.eidu.api.pagination.IndexedPaginatedResponse

type GetEntityTypesParameters = { pageIndex: number; pageSize: number }

const getEntityTypes = async ({
  pageIndex,
  pageSize,
}: GetEntityTypesParameters): Promise<IndexedPaginatedResponse<EntityType> | null> => {
  requireValidPaginationParameters(pageIndex, pageSize)
  const authContext = await requireAuthContext()

  const url = `${entityApiUrl}/organizations/${authContext.organizationId}/types?pageIndex=${pageIndex}&pageSize=${pageSize}`
  console.debug('[getEntityTypes] fetch start', {
    url,
    tokenSuffix: authContext.accessToken.slice(-6),
    pageIndex,
    pageSize,
  })

  return fetch(url, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response) => {
    console.debug('[getEntityTypes] response', { status: response.status })
    switch (response.status) {
      case 200:
        return entityTypePaginatedResponseFromJsonString(await response.text()) as IndexedPaginatedResponse<EntityType>
      case 404:
        console.warn(`Got status ${response.status} from getEntityTypes endpoint`)
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityTypes endpoint`)
    }
  })
}

export default getEntityTypes
